import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import * as _ from 'lodash';

@Component({
    selector: 'accrual-paid-date-precedences-modal',
    templateUrl: './accrual.paid.date.precedences.modal.component.html',
    standalone: false
})
export class AccrualPaidDatePrecedencesModalComponent implements OnInit {
    constructor(
        private bsModalRef: BsModalRef,
        private readonly _toastr: ToastrService
    ) {
    }

    //initialState
    companyId: number;
    accrualPaidDatePrecedences: Core.CompanyAccrualPaidDatePrecedenceModel[];
    canEdit: boolean;
    onClose: (accrualPaidDatePrecedences?: Core.CompanyAccrualPaidDatePrecedenceModel[]) => void;


    async ngOnInit() {
        this.accrualPaidDatePrecedences = _.sortBy(this.accrualPaidDatePrecedences, ['accrualPaidDateTypeId']) || [];
    }

    onChangeIsSelected(precedence: any): void {
        precedence = precedence as Core.CompanyAccrualPaidDatePrecedenceModel;

        if (precedence.isSelected) {
            // Default Order of Precedence to 1 + largest existing Order, or 1 for first selected.
            const largestOrder = _.maxBy(this.accrualPaidDatePrecedences, (x) => {
                return x.isSelected ? x.orderOfPrecedence : 0;
            }).orderOfPrecedence || 0;
            precedence.orderOfPrecedence = largestOrder + 1;
        } else {
            // Zero Order of Precedence for unselected Date Type.
            const removedOrder = precedence.orderOfPrecedence;
            precedence.orderOfPrecedence = 0;

            _.forEach(this.accrualPaidDatePrecedences, (x) => {
                if (x.isSelected && x.orderOfPrecedence > removedOrder) {
                    x.orderOfPrecedence--;
                }
            });
        }
    }

    cancel(): void {
        this.bsModalRef.hide();
    }

    save(): void {
        const validationError = this._validatePrecedences();
        if (validationError) {
            this._toastr.error(validationError);
            return;
        }

        this.bsModalRef.hide();
        this.onClose(this.accrualPaidDatePrecedences);
    }

    private _validatePrecedences(): string {
        // Validate at least one precedence has IsSelected=true.
        const anySelected: boolean = _.some(this.accrualPaidDatePrecedences, ['isSelected', true]);
        if (!anySelected) {
            return 'At least one Date Type must be Selected';
        }

        return null;
    }
}
